import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useFilter } from "../component/VerifyEmail";
import { Container, Row, Col } from "reactstrap";
import { Puff } from "react-loader-spinner";

const CategoryPage = () => {
  const [CategoryData, setCategoryData] = useState([]);
  const { handleFilterCategory, handleFilterSubCategory } = useFilter();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/auth/list/CategoryMaster`,
    );
    setCategoryData(res.data);
    setIsLoading(false);
    console.log(res);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      {isLoading ? (
        <div className='loader-container'>
          <Puff color='#a01e20' height={50} width={50} timeout={0} />
        </div>
      ) : (
        <main className='main'>
          <nav className='breadcrumb-nav mb-3'>
            <Container>
              <ul className='breadcrumb'>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                <li>All Categories</li>
              </ul>
            </Container>
          </nav>

          <Container className='pb-5'>
            <Row>
              <Col lg='12'>
                <Row className="category-wrapper cols-12 cols-lg-7 cols-md-2 cols-sm cols-xl-8 pt-4 align-items-center">
                  {CategoryData.map((category, index) => (
                    <Col
                      key={index}
                      xs="4"
                      sm="4"
                      md="4"
                      lg="4"
                      xl="4"
                      className="category category-ellipse mb-3 col-sm large-sm-col"
                    >
                      <div className="category-media">
                        <Link
                          to={`/product-list?category=${category._id}&categoryName=${encodeURIComponent(category.categoryName)}`}
                          onClick={() => handleFilterCategory(category._id)}>
                          <img
                            src={`${process.env.REACT_APP_API_URL}/${category.logo}`}
                            alt={category.categoryName}
                            width="190"
                            height="190"
                            onError={(e) => {
                              e.target.src = `${process.env.REACT_APP_API_URL}/${category.logo}`;
                            }}
                          />
                        </Link>
                      </div>

                      <div className="category-content">
                        <h4 className="category-name">
                          <Link
                            to={`/product-list?category=${category._id}&categoryName=${encodeURIComponent(category.categoryName)}`}
                            onClick={() => handleFilterCategory(category._id)}>
                            {category.categoryName}
                          </Link>
                        </h4>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </main>
      )}
    </React.Fragment>
  );
};

export default CategoryPage;
